let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0hAWq")).then(() => parcelRequire('yL7Pr'));